import { getData, postData } from "../../utils/http";
import { saveBysessionStorage, returnBySessionStorage, saveBylocalStorage, returnBylocalStorageData } from "../../utils/storage";
import { getApplicationCode } from "@/utils/user";
//实现框架基础功能的基本数据
export default {
	namespaced: true,
	state: {
		//侧边菜单
		menuList: [],
		menuLoading: true,
		//应用列表
		appList: returnBylocalStorageData("LOCAL_APP_LIST") ? returnBylocalStorageData("LOCAL_APP_LIST") : [],
		//历史导航
		historyTopTabMenuList: returnBySessionStorage("HISTORY_TOP_TABMENULIST") ? JSON.parse(returnBySessionStorage("HISTORY_TOP_TABMENULIST")) : [],
		//当前显示的导航
		activeHistoryTabItem: returnBySessionStorage("ACTIVE_HISTORY_TSB_ITEM") ? JSON.parse(returnBySessionStorage("ACTIVE_HISTORY_TSB_ITEM")) : null,
		//共用的组织机构列表
		appPublicOrg:[],
		//选中的组织机构列表
		isSectOrg:"",
		//用户信息
		userInfo:{
			name:"",
			code:"",
			roleNames:""
		}
	},

	mutations: {
		SET_MENU_LIST(state, menuList) {
			state.menuList = menuList;
			//写入缓存
			saveBylocalStorage("ROLE_MENU_LIST", JSON.stringify(menuList));
		},
		MENU_LOADING(state, loading) {
			state.menuLoading = loading;
		},
		//写入历史导航
		SET_HISTORY_TOP_TABMENULIST(state, targetData) {
			if (targetData.data) {
				var oldList = state.historyTopTabMenuList;
				//添加
				if (targetData.type == "add") {
					var addFlag = true;
					for (var i = 0; i < oldList.length; i++) {
						if (oldList[i]["name"] == targetData.data.name) {
							addFlag = false;
						}
					}
					if (addFlag) {
						oldList.push(targetData.data);
						state.historyTopTabMenuList = oldList;
					}
					state.activeHistoryTabItem = targetData.data;
					saveBysessionStorage("HISTORY_TOP_TABMENULIST", JSON.stringify(state.historyTopTabMenuList));
					saveBysessionStorage("ACTIVE_HISTORY_TSB_ITEM", JSON.stringify(targetData.data));
				}
				//移除
				else {
					var removeIndex = "";
					for (var i = 0; i < oldList.length; i++) {
						if (oldList[i]["name"] == targetData.data.name) {
							removeIndex = i;
						}
					}
					oldList.splice(removeIndex, 1);
					state.historyTopTabMenuList = oldList;
					saveBysessionStorage("HISTORY_TOP_TABMENULIST", JSON.stringify(state.historyTopTabMenuList));

					//如果移除的是非选中路由，则不需要修改选中状态
					if (targetData.data.name == state.activeHistoryTabItem.name) {
						if (!oldList[removeIndex - 1] && !oldList[removeIndex]) {
							state.activeHistoryTabItem = null;
							saveBysessionStorage("ACTIVE_HISTORY_TSB_ITEM", null);
						} else {
							state.activeHistoryTabItem = oldList[removeIndex - 1] || oldList[removeIndex];
							saveBysessionStorage("ACTIVE_HISTORY_TSB_ITEM", JSON.stringify(oldList[removeIndex - 1] || oldList[removeIndex]));
						}
					}
				}
			} else {
				state.activeHistoryTabItem = null;
				saveBysessionStorage("ACTIVE_HISTORY_TSB_ITEM", null);
			}
		},
		//写入app列表
		SET_APP_LIST(state, data) {
			state.appList = data;
			saveBylocalStorage("LOCAL_APP_LIST", data);
		},
		//修改选中的组织机构
		APP_ORG(state, data) {
			state.isSectOrg = data;
		},
		//修改用户信息
		USER_INFO(state, data) {
			state.userInfo = data;
			saveBysessionStorage("USER_INFO", data.permissions);
		}
	},
	actions: {

		//获取所有菜单
		getMenuList({ commit }) {
			return new Promise(async (resolve) => {
				getData(getApplicationCode() + `/index/data`).then((res) => {
					if (res.state == 1) {
						commit("SET_MENU_LIST", res.data.routers);
						commit("USER_INFO", res.data.authUser);
						resolve(true);
					} else {
						resolve(false);
						commit("SET_MENU_LIST", []);
					}
				});
			})
		},
		//获取我的应用
		getMyAppList({ commit }) {
			return new Promise(async (resolve) => {
				getData(`auth/data`).then((res) => {
					if (res.state == 1) {
						commit("SET_APP_LIST", res.data.applications);
					}
					resolve(res);
				});
			})
		},
		
		//获取组织机构列表
		getAllowOrg({ commit, state }, year) {
			return new Promise((resolve) => {
				getData(`logistics/sys/dept/get/list`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data
						});
						state.appPublicOrg=res.data;
						if(res.data.length>0){
							state.isSectOrg=res.data[0]["id"];
						}
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						});
						state.appPublicOrg=[];
					}
				})
			})
		},


		//新建菜单
		addHistoryTopTabMenu({ commit, state }, addData) {

			//兼容name为空的情况，比如首页
			if (addData && addData['name']) {
				//构建顶部缓存菜单数据时，从菜单列表中查询下标
				var toMenuIndex = "";
				for (var i = 0; i < state.menuList.length; i++) {
					for (var j = 0; j < state.menuList[i]["children"].length; j++) {
						if (state.menuList[i]["children"][j]['name'] == addData['name']) {
							toMenuIndex = `${i}-${j}`
						}
					}
				}
				if (toMenuIndex) {
					addData['activeIndex'] = toMenuIndex;
				}
			}


			commit("SET_HISTORY_TOP_TABMENULIST", {
				data: addData,
				type: "add"
			});
		},
		//关闭单个菜单
		closeHistoryTOpMenu({ commit }, removeData) {
			commit("SET_HISTORY_TOP_TABMENULIST", {
				data: removeData,
				type: "remove"
			})
		},
		//修改loading
		changeMenuLoading({ commit }, value) {
			commit("MENU_LOADING", value);
		},
		//修改选中的组织机构
		changeAppOrg({ commit }, value) {
			commit("APP_ORG", value);
		},
	}
}